import { Component, Vue, PropSync } from 'vue-property-decorator';
import template from './RowPlaceholder.vue';

@Component({
	mixins: [template]
})
export default class RowPlaceholder extends Vue {
	@PropSync('rows', { type: Number }) rowsSync!: number;

	@PropSync('colspan', { type: Number }) colspanSync!: number;
}
